import React from 'react';
import { motion } from 'framer-motion';
export function AgitationSection() {
  return <section className="w-full py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-15">
      <div className="max-w-3xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="space-y-8 text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-17">
          <p data-id="element-18">You love your child more than you have words for.</p>
          <p data-id="element-19">That is not the question. That has never been the question.</p>
          <p data-id="element-20">
            The question is why, despite every book you've read, every YouTube
            rabbit hole you've gone down at midnight, every tip from every
            well-meaning therapist, school counselor and Facebook group
            moderator — the meltdowns keep coming.
          </p>
          <p data-id="element-21">
            And every single time one hits, you feel it in your chest before
            it's even over.
          </p>
          <p data-id="element-22">
            The guilt. The helplessness. The quiet, exhausting voice in the back
            of your mind that says:
          </p>
          <blockquote className="border-l-4 border-amber pl-6 py-2 my-8 text-2xl font-serif text-charcoal italic" data-id="element-23">
            "I should be better at this by now."
          </blockquote>
          <p data-id="element-24">
            You're not alone in that voice. But I need you to hear something
            important:
          </p>
          <p className="font-semibold text-charcoal text-2xl pt-4" data-id="element-25">
            That voice is lying to you.
          </p>
          <p className="text-xl" data-id="element-26">
            You are not failing your child. You are operating without the right
            system. And there is a profound difference between those two things.
          </p>
        </motion.div>
      </div>
    </section>;
}